import React from 'react';
import aboutImage from '../assets/images/Image_fx (48).jpg';

const About = () => {
  return (
    <section className="about_home_wrap">
      <div className="about_home_top">
        <div aria-hidden={true} className="about_bottom_heading is-tablet u-text-display">공간에 시간의 흐름을 새기고</div>
        <h2 className="about_bottom_heading u-text-display u-sr-only">공간에 시간의 흐름을 새기고</h2>
        <div aria-hidden={true} className="about_bottom_heading u-text-display">공간에 시간의 흐름을 새기고</div>
        <div className="about_home_bottom u-grid-custom">
          <div id="w-node-_8d96edb0-3b79-668d-4e5e-ed0e0b34196e-5ee71fd0" className="about_bottom_contain u-text-display">
            <div data-image-reveal="" className="about_image_cover">
              <div data-image-cover="" className="g_image_cover"></div>
              {aboutImage && (
                <img
                  src={aboutImage}
                  loading="lazy"
                  width="512"
                  data-image=""
                  alt="A person standing in a modern, minimalist room with a large window."
                  className="about_bottom_image"
                />
              )}
            </div>
            <div className="about_bottom_heading">매 순간 새로운 경험</div>
          </div>
        </div>
      </div>
      
      {/* Video Modal */}
      <div className="video-modal" id="videoModal" style={{display: 'none'}}>
        <div className="video-modal-overlay" data-video-close=""></div>
        <div className="video-modal-content">
          <button className="video-modal-close" data-video-close="">
            <span>&times;</span>
          </button>
          <div className="video-modal-video">
            <iframe
              id="videoFrame"
              title="Video"
              width="100%"
              height="100%"
              src=""
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
      
      <div className="about_home_content u-grid-custom">
        <div id="w-node-_193310b5-e1da-c1a1-eb66-06787bf79b86-5ee71fd0" className="about_content_wrap">
          <div className="about_content_contain">
            <p className="about_content_paragraph u-text-large u-sr-only">
              빛과 그림자를 활용하여 공간에 시간의 흐름을 새기고, 사용자에게 매 순간 새로운 경험을 선사하는 공간을 설계합니다.
            </p>
            <p aria-hidden={true} data-lines-split="" data-animate-scroll="" className="about_content_paragraph u-text-large">
              빛과 그림자를 활용하여 공간에 시간의 흐름을 새기고, 사용자에게 매 순간 새로운 경험을 선사하는 공간을 설계합니다.
              <span aria-hidden={true} className="u-splittext-spacer"></span>
              공간은 그 안에 머무는 사람을 중심으로 디자인됩니다. 사용자의 동선과 라이프스타일을 반영하여, 삶을 풍요롭게 하는 공간을 창조합니다.
            </p>
            <a data-link-hover="" data-wf--btn-main--variant="base" href="/studio" className="btn_default_wrap w-inline-block">
              <div className="btn_default_contain">
                <div data-link="" className="btn_default_text">자세히보기</div>
              </div>
              <div className="g_circle is-light"></div>
            </a>
          </div>
          <div className="about_eyebrow_contain">
            <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;